import React from 'react';
import { Button, Input, Form, Row, Col, Spin } from 'antd';

import * as numeral from 'numeral';
import { moneyFormat } from '../../common/constants';
import "./application.less";

const BulkApplication = (details, translate, form, onCancel, onApprove, modalType, loading) => {
  const totalAmount = details.reduce((a, { loan_amount }) => a + Number(loan_amount), 0)
  return (
      <>
        {
          loading ? <Spin tip={translate("generic.loadingData")} /> :
          <>
            <Row className='bulk-approval-modal-total-amount-row'>
            <Col span={10}>{translate('applicationApprovalModal.ovo_admin_label_total_loan_amount')}</Col>
            <Col span={10} offset={4} className='bulk-approval-modal-total-amount-col2'>{numeral(totalAmount).format(moneyFormat)}</Col>
            </Row>
            <Row className='bulk-approval-modal-btn-row'>
              <Button className='bulk-approval-modal-btn' type="secondary" onClick={onCancel}>
                {translate('applicationApprovalModal.button_cancel')}
              </Button>
              <Button className='bulk-approval-modal-btn' type="primary" onClick={() => onApprove(details)}>
                {translate('applicationApprovalModal.button_confirm')}
              </Button>
            </Row>
            {
              modalType === "approve" ? 
              <Row className='bulk-approval-modal-description'>{translate('applicationApprovalModal.ovo_admin_body_confirm_loan_amount')}</Row> :
              <></>
            }
          </>
        }
      </>
  );
}

export default BulkApplication;
